<template>
  <div>
    <v-radio-group
      v-model="activeOptionValue"
      class="radio-group__container"
      hide-details
      required
      inline
      :disabled="disabled"
    >
      <div v-for="option in options"
            :key="`option-${option.value}`"
            :value="option"
            :class="[
              {'radio-group__item--active': option.value === activeOption},
              {'radio-group__item--disabled': disabled}]"
            class="radio-group__item py-4 px-6"
            :data-locator="`${option.value}-share-option`"
            @click="activeOptionValue = option.value"
        >
        <span class="text-truncated text--small">
          {{ option.name }}
        </span>
      </div>
    </v-radio-group>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppRadioGroup',
  props: {
    activeOption: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      activeOptionValue: this.activeOption,
    }
  },
  watch: {
    activeOption : {
      immediate: true,
      handler (value) {
        this.activeOptionValue = value
      },
    },
    activeOptionValue (value) {
      this.$emit('change-active-option', value)
    },
  },
})
</script>

<style lang="scss">
.radio-group {
  &__container {
    .v-selection-control-group--inline {
      width:100%;
      column-gap: 24px;
    }

    .radio-group__item {
      align-content: center;
      border-radius: 8px;
      cursor: pointer;
      display: flex;
      flex: 1;
      justify-content: start;
      outline: 1px solid rgb(var(--v-theme-grey-200));
      transition: all .12s ease-in-out;

      &--active {
        background-color: rgb(var(--v-theme-info-lighten-5));
        outline: 2px solid rgb(var(--v-theme-info-darken-1));
        cursor: default;
      }

      &--disabled {
        cursor: not-allowed;
      }
    }
  }
}
</style>
